// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3DHFO","content":"Consent_content__1YiqH","footer":"Consent_footer__3b-Wx"};